<div class="unconfirmed-login">
  <div class="row text-center">
    <div class="col-sm-12">
      <h2 class="heading">You're Almost There!</h2>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-6 offset-md-3 text-center">
      <div class="text-copy">
        We've found your account, you just need to confirm your email address via the invitation we emailed you.
        If you'd prefer we can email you another invitation now via the button below.
        If you have any questions do not hesitate to reach out to us at
        <a textCta="light" href="mailto:{{ 'supportEmail' | branding | async }}">{{ 'supportEmail' | branding | async }}</a> or
        <a textCta="light" href="tel:215-607-8942">(215) 607-8942</a>
      </div>
      <br>
      <button id="resend-invitation-button" class="btn btn-primary" (click)="renewInvitation()">Resend Invitation</button>
    </div>
  </div>
</div>
